/* eslint-disable */
import { ColumnChooser, ColumnDirective, ColumnsDirective, CommandColumn, Edit, Filter, GridComponent, Group, Inject, Page, Sort, Toolbar, Selection } from '@syncfusion/ej2-react-grids'
import React, { useState } from 'react'
import Avatar from "@components/avatar"
import { Check, X } from "react-feather"
import { Badge } from "reactstrap"
import { italian } from '../../../../@core/translation-syncfusion/grid-translation/it-IT'
import { L10n, setCulture } from '@syncfusion/ej2-base'
import useFetch from '../../../../@core/auth/apiService/useFetch'
import { configGetProdottiMagazzino } from '../../../../@core/auth/apiService/configs'
//SET TRADUZIONE 
setCulture('it-IT')
L10n.load(italian)


const constructor = {

    editOptions: { allowEditing: true, allowDeleting: true },
    commands:
        [
            {
                type: 'Aggiungi',
                id: 'aggiungiSingolo',
                buttonOption: {
                    iconCss: 'e-icons e-plus',
                    cssClass: 'e-flat'
                }
            }
        ]
}


const toolbarCustomItem = [
    { text: 'Print' },
    { text: 'Aggiungi', tooltipText: 'Aggiungi Selezionati', prefixIcon: 'e-plus', id: 'aggiungiProdotti' },
    'ColumnChooser'
]
function attivoTemplate(data) {
    if (data.attivo === 1) {
        return (<Avatar color="success" icon={<Check color='white' size={15} />}></Avatar>)
    } else if (data.attivo === 0) {
        return (<Avatar color="danger"><X size={15} /></Avatar>)
    }
}
function disponibileTemplate(data) {

    if (data.disponibile === 1) {
        return (<Avatar color="success" icon={<Check color='white' size={15} />}></Avatar>)
    } else if (data.disponibile === 0) {
        return (<Avatar color="danger"><X size={15} /></Avatar>)
    }
}
function tipologiaTemplate(data) {
    return (
        <Badge color={data.tipoProdotto === 'Unificato' ? 'primary' : 'secondary'}>
            {data.tipoProdotto}
        </Badge>)
}


const TabellaWareHouseSecondaria = (props) => {
    const { idProdotto, idMagazzino, value, pullData } = props
    const [prodottiDaLavorare, setProdottiDaLavorare] = useState(value)
    const { data, isLoading } = useFetch(configGetProdottiMagazzino([{ idMagazzino }]))
    let prodotti = data.prodotti
    let grid
    if (prodotti && idProdotto != undefined) {
        prodotti = prodotti.filter(e => e.id === Number(idProdotto))
    } else if (prodotti && idProdotto === undefined) {
        prodotti = prodotti
    }



    const rowSelected = () => { } // ????? se lo levo non funziona più
    //Ho diviso le due funzioni per permettere al custom button Elimina di poter funzionare.


    //FUNZIONE PER AGGIUNGERE PRODOTTO A PRODOTTIASSOCIATI NO DUPLICATI
    const addProduct = (prodotto) => {
        if (!prodottiDaLavorare.find(element => element.id == prodotto.id)) { prodottiDaLavorare.push(prodotto) }
        pullData(prodottiDaLavorare)
    }
    const addRecords = () => {
        let recordSelezionati = grid.getSelectedRecords()
        recordSelezionati.forEach(e => { if (!prodottiDaLavorare.find(element => element.id == e.id)) { prodottiDaLavorare.push(e) } })
        pullData(prodottiDaLavorare)
    }
    //BUTTON AggiungiSingolo
    const customButton = (args) => {
        if (args.commandColumn.id === 'aggiungiSingolo') addProduct(args.rowData)
    }

    // BUTTONS AZIONI DELLA TOOLBAR 
    const clickHandler = (args) => {
        if (args.item.id === 'aggiungiProdotti') addRecords()
    }

    if (!isLoading) {
        return (
            <div style={{ height: '95% !important', marginBottom: '100px' }}>
                <GridComponent allowPaging={true}
                    rowHeight={26}
                    dataSource={prodotti}
                    rowSelected={rowSelected}
                    selectionSettings={{ checkboxMode: 'ResetOnRowClick', enableToggle: true, checkboxOnly: true }}
                    allowSelection={true} allowFiltering={true}
                    pageSettings={{
                        pageSizes: [25, 50, 100, 200],
                        pageSize: 50
                    }}
                    showColumnChooser={true}
                    toolbar={toolbarCustomItem}
                    filterSettings={{ type: "Menu" }}
                    allowSorting={true} editSettings=
                    {{
                        allowEditing: false,
                        allowDeleting: false
                    }}
                    ref={g => (grid = g)}
                    toolbarClick={clickHandler}
                    commandClick={customButton}
                >
                    <ColumnsDirective>
                        <ColumnDirective type='checkbox' width='30' />
                        <ColumnDirective field='azioni' width='70' textAlign="left" showInColumnChooser={false} allowFiltering={false} commands={constructor.commands} displayHtmlEncode={false} />
                        <ColumnDirective field='id' width='30' visible={false} isPrimaryKey={true} />
                        <ColumnDirective field='codice' width='100' />
                        <ColumnDirective field='nome' width='200' textAlign="center" clipMode='EllipsisWithTooltip' />
                        <ColumnDirective field='quantita' width='200' />
                        <ColumnDirective field='tipoProdotto' width='100' format="C2" textAlign="center" template={tipologiaTemplate} />
                        <ColumnDirective field='prezzoVendita' visible={false} width='100' headerText='prezzo' />
                        <ColumnDirective field='costo' visible={false} width='100' />
                        <ColumnDirective field='unitaMisura' visible={false} width='100' />
                        <ColumnDirective field='attivo' visible={false} width='100' template={attivoTemplate} />
                        <ColumnDirective field='disponibile' visible={false} width='100' template={disponibileTemplate} />
                    </ColumnsDirective>
                    <Inject services={[Page, Sort, Filter, Group, CommandColumn, Edit, Toolbar, ColumnChooser, Selection]} />
                </GridComponent>
            </div>
        )
    }
}

export default TabellaWareHouseSecondaria
